import { Breadcrumb, Button, Card, Col, Empty, InputNumber, message, Modal, Row, Select, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, MutationFn, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import {
  MarketingActivityRuleKey,
  MarketingActivityRuleType,
  ReservationDiscountSchema,
} from '../../types/marketingActivity';

const RESERVE_C39X_RULE_NAME = '折扣';
const RESERVE_C39X_URL = 'congmingpai.com/api/promotion/go?channel=wx-reservation-c39x-sale&extra=';

const getEnrollmentGroupsQuery = gql`
  query getEnrollmentGroups($ids: [ID], $teacherIds: [ID], $skuIds: [ID], $name: String) {
    enrollmentGroups(ids: $ids, teacherIds: $teacherIds, skuIds: $skuIds, name: $name) {
      id
      name
    }
  }
`;

interface GenerateLinkData {
  id: number;
  enrollmentGroupName: string;
  link: string;
}

const createMarketingActivityRuleMutation = gql`
  mutation createMarketingActivityRule($activityId: Int, $rules: [JSON]) {
    createMarketingActivityRule(activityId: $activityId, rules: $rules) {
      id
    }
  }
`;

interface Discount {
  amount?: number;
  reservedCount?: number;
  stage?: number;
}

interface State {
  selectedEnrollmentGroups: string[];
  isConfirmModalVisible: boolean;
  dataSource: GenerateLinkData[];
  addDiscountStages: number[];
}

export class ReserveActivityConfig extends Component<RouteComponentProps<{ id: string }>, State> {
  private discountsData: Discount[] = [];
  private enrollmentGroups: { id: number; name: string }[];

  constructor(props: RouteComponentProps<{ id: string }>) {
    super(props);
    this.state = {
      selectedEnrollmentGroups: [],
      isConfirmModalVisible: false,
      dataSource: [],
      addDiscountStages: [], // 默认三个阶段
    };
  }

  getEnrollmentGroups() {
    return (
      <Query query={getEnrollmentGroupsQuery}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const { enrollmentGroups } = data;
          this.enrollmentGroups = enrollmentGroups;

          return (
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="选择社群"
              onChange={(value: string[]) => {
                this.setState({
                  selectedEnrollmentGroups: value,
                });
              }}
            >
              {enrollmentGroups.map((enrollmentGroup: { id: number; name: string }) => {
                return <Select.Option key={enrollmentGroup.id}>{enrollmentGroup.name} </Select.Option>;
              })}
            </Select>
          );
        }}
      </Query>
    );
  }

  generateLinkData() {
    const { selectedEnrollmentGroups } = this.state;

    const selectedEnrollmentGroupsData = this.enrollmentGroups.filter(enrollmentGroup => {
      const selectedEnrollmentGroup = selectedEnrollmentGroups.find(id => {
        return id === String(enrollmentGroup.id);
      });
      return selectedEnrollmentGroup;
    });

    const dataSource = selectedEnrollmentGroupsData.map(item => {
      return {
        id: item.id,
        key: item.id,
        enrollmentGroupName: item.name,
        link: `${RESERVE_C39X_URL}${item.id},${this.props.match.params.id}`,
      };
    });

    this.setState({
      dataSource,
    });
  }

  setDiscounts(reservedCount: number, stage: number) {
    if (this.discountsData.length === 0) {
      this.discountsData.push({ reservedCount, stage });
      return;
    }

    const discount = this.discountsData.find(discount => {
      return stage === discount.stage;
    });

    if (!discount) {
      this.discountsData.push({ reservedCount, stage });
      return;
    }

    for (const discount of this.discountsData) {
      if (stage === discount.stage) {
        discount.reservedCount = reservedCount;
        return;
      }
    }
  }

  addDiscounts() {
    const { addDiscountStages } = this.state;
    if (addDiscountStages.length === 0) {
      // 默认的有三个阶段
      addDiscountStages.push(4);
      this.setState({ addDiscountStages });
      return;
    }

    const lastStage = addDiscountStages[addDiscountStages.length - 1];
    addDiscountStages.push(lastStage + 1);
    this.setState({ addDiscountStages });
    return;
  }

  async onConfirmModalHandleOk(
    createMarketingActivityRuleMutation: MutationFn<
      any,
      {
        activityId: number;
        rules: {
          ruleKey: MarketingActivityRuleKey;
          ruleName: string;
          ruleType: number;
          ruleValue: ReservationDiscountSchema;
        }[];
      }
    >,
  ) {
    const { selectedEnrollmentGroups } = this.state;

    this.setState({ isConfirmModalVisible: false });

    if (selectedEnrollmentGroups.length === 0) {
      message.error('请选择社群！');
      return;
    }

    if (this.discountsData.length === 0) {
      message.error('请填写预约等级！');
      return;
    }

    if (this.discountsData.length < 3) {
      message.error('预约等级最少为3级,请继续填写！');
      return;
    }

    const invalidDiscount = this.discountsData.find(item => {
      return !item.reservedCount || !item.amount;
    });

    if (invalidDiscount) {
      message.error('预约等级配置有错误有错误！');
      return;
    }

    try {
      await createMarketingActivityRuleMutation();
      this.generateLinkData();
      message.success(' 新增成功！');
    } catch {
      message.error('新增失败！');
    }
  }

  setAmount(discountAmount: number, stage: number) {
    if (this.discountsData.length === 0) {
      this.discountsData.push({ stage, amount: discountAmount });
      return;
    }

    const discount = this.discountsData.find(discount => {
      return stage === discount.stage;
    });

    if (!discount) {
      this.discountsData.push({ stage, amount: discountAmount });
      return;
    }

    for (const discount of this.discountsData) {
      if (stage === discount.stage) {
        discount.amount = discountAmount;
        return;
      }
    }
  }

  render() {
    const { selectedEnrollmentGroups, addDiscountStages, dataSource } = this.state;
    const activityId = Number(this.props.match.params.id);
    const ruleKey = MarketingActivityRuleKey.DETAIL_RESERVATION_DISCOUNT;
    const ruleName = RESERVE_C39X_RULE_NAME;
    const ruleType = MarketingActivityRuleType.DETAIL;

    const discounts = this.discountsData.map(discount => {
      return {
        amount: discount.amount,
        reservedCount: discount.reservedCount,
      };
    });

    const rules = selectedEnrollmentGroups.map(enrollmentGroup => {
      return {
        ruleKey,
        ruleName,
        ruleType,
        ruleValue: {
          discounts,
          groupId: Number(enrollmentGroup),
        },
      };
    });

    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/marketing`}>营销活动</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>活动配置</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Row gutter={24}>
            <Col span={2} style={{ marginTop: '6px', textAlign: 'right' }}>
              选择社群:
            </Col>
            <Col span={9}>{this.getEnrollmentGroups()}</Col>
          </Row>
          <Row gutter={24} style={{ marginTop: '10px' }}>
            <Col span={2} style={{ marginTop: '6px', textAlign: 'right' }}>
              预约等级:
            </Col>
            <Col span={10}>
              <Row gutter={24}>
                <Col span={12}>
                  <span style={{ marginRight: '5px' }}> 预约等级1(人数):</span>
                  <InputNumber
                    min={0}
                    onChange={(value: number) => {
                      this.setDiscounts(value, 1);
                    }}
                  />
                </Col>
                <Col span={12}>
                  <span style={{ marginRight: '5px' }}> 折扣金额(元):</span>
                  <InputNumber
                    min={0}
                    onChange={(value: number) => {
                      this.setAmount(value, 1);
                    }}
                  />
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: '5px' }}>
                <Col span={12}>
                  <span style={{ marginRight: '5px' }}> 预约等级2(人数):</span>
                  <InputNumber
                    min={0}
                    onChange={(value: number) => {
                      this.setDiscounts(value, 2);
                    }}
                  />
                </Col>
                <Col span={12}>
                  <span style={{ marginRight: '5px' }}> 折扣金额(元):</span>
                  <InputNumber
                    min={0}
                    onChange={(value: number) => {
                      this.setAmount(value, 2);
                    }}
                  />
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: '5px' }}>
                <Col span={12}>
                  <span style={{ marginRight: '5px' }}> 预约等级3(人数):</span>
                  <InputNumber
                    min={0}
                    onChange={(value: number) => {
                      this.setDiscounts(value, 3);
                    }}
                  />
                </Col>
                <Col span={12}>
                  <span style={{ marginRight: '5px' }}> 折扣金额(元):</span>
                  <InputNumber
                    min={0}
                    onChange={(value: number) => {
                      this.setAmount(value, 3);
                    }}
                  />
                </Col>
              </Row>
              {addDiscountStages.map(item => {
                return (
                  <Row gutter={24} style={{ marginTop: '5px' }} key={item}>
                    <Col span={12}>
                      <span style={{ marginRight: '5px' }}> 预约等级{item}(人数):</span>
                      <InputNumber
                        min={0}
                        onChange={(value: number) => {
                          this.setDiscounts(value, item);
                        }}
                      />
                    </Col>
                    <Col span={12}>
                      <span style={{ marginRight: '5px' }}> 折扣金额(元):</span>
                      <InputNumber
                        min={0}
                        onChange={(value: number) => {
                          this.setAmount(value, item);
                        }}
                      />
                    </Col>
                  </Row>
                );
              })}
            </Col>
            <Col span={1}>
              <Button
                type="primary"
                onClick={() => {
                  this.addDiscounts();
                }}
              >
                添加等级
              </Button>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={3} style={{ marginTop: '6px' }}>
              <Button
                style={{ marginLeft: '40px' }}
                type="primary"
                onClick={() => {
                  this.setState({
                    isConfirmModalVisible: true,
                  });
                }}
              >
                确认添加
              </Button>
            </Col>
          </Row>
          <Row gutter={24}>
            <Mutation
              mutation={createMarketingActivityRuleMutation}
              variables={{
                activityId,
                rules,
              }}
            >
              {createActivityRecordMutation => {
                return (
                  <Modal
                    title="Basic Modal"
                    visible={this.state.isConfirmModalVisible}
                    onCancel={() => {
                      this.setState({
                        isConfirmModalVisible: false,
                      });
                    }}
                    onOk={async () => {
                      await this.onConfirmModalHandleOk(createActivityRecordMutation);
                    }}
                  >
                    确认添加吗？
                  </Modal>
                );
              }}
            </Mutation>
          </Row>
          <Row gutter={24}>
            <Col span={16}>
              <Table
                size="small"
                columns={[
                  {
                    title: 'ID',
                    key: 'ID',
                    dataIndex: 'id',
                  },
                  {
                    title: '社群',
                    key: 'enrollmentGroupName',
                    dataIndex: 'enrollmentGroupName',
                  },
                  {
                    title: '链接',
                    key: 'link',
                    dataIndex: 'link',
                  },
                ]}
                dataSource={dataSource}
                style={{ marginTop: '10px', marginLeft: '40px' }}
              />
            </Col>
          </Row>
        </Card>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/ReserveActivityConfig.tsx